<p-menubar [model]="sortItems" class="menubar-item" expandMode="inline"></p-menubar>